<template>
    <div class="muic-survey-wrapper">

        <!-- Header Section -->
        <div class="muic-survey-header">
            <div class="muic-survey-header-content">
                <div class="mb-10 text-center">
                    <img class="logo-size" src="images/logo_muic.png" alt="MUIC" />
                </div>
                <!--  
                    <div v-if="compleateForm">
                        <h6 class="muic-survey-title font-web"> Graduate <a-icon class="text-success" style="font-size: 16px;" type="check-circle" theme="filled" />  </h6>
                        <p style="font-size: 12px;" class="muic-survey-subtitle font-web-bold text-muted"><a href="http://" target="_blank" rel="noopener noreferrer">( PDPA MUIC Graduate Employment Survey of Academic Year 2023 )</a></p>
                    </div>
                    <div v-else>
                        <h6 class="muic-survey-title font-web">Graduate Employment Survey</h6>
                        <p style="font-size: 12px;" class="muic-survey-subtitle font-web-bold text-muted">แบบสำรวจภาวะมีงานทำ ส่วนของมหาวิทยาลัยมหิดล</p>
                        <p style="font-size: 12px;" class="muic-survey-subtitle font-web-bold text-muted"><a href="http://" target="_blank" rel="noopener noreferrer">( PDPA MUIC Graduate Employment Survey of Academic Year 2023 )</a></p>
                    </div>
                -->
            </div>
        </div>

        <!-- Card Container -->
        <a-card :bordered="false" class="muic-survey-card" :bodyStyle="{ paddingTop: 0 }">
            <template #title>
                <a-row type="flex" justify="space-between" align="middle" class="muic-survey-header-row">
                    <!-- ซ้าย: หัวข้อ -->
                    <a-col :xs="24" :sm="24" class="muic-survey-heading-col">
                        <h5 class="muic-survey-heading mt-0 mb-0 font-web-bold"></h5>
                        <h5 class="muic-survey-heading mt-0 mb-10 font-web-bold">

                        </h5>
                        <a-space size="large" class="mt-10 muic-avatar-space">
                            <div class="mt-10">
                                <a-avatar :size="60" shape="square" :src="picture"
                                    style="width: 60px; height: 60px; border-radius: 10px;" />
                                <br>
                                <a style="font-size: 12px;" href="#" @click.prevent="signOut"><span
                                        class="text-danger font-weight-bold"><a-icon style="font-size: 12px;"
                                            class="mr-10" type="logout" />Sign out</span></a>
                            </div>
                            <div class="avatar-info">
                                <h4 class="font-web-bold mt-0">{{ fullname }}</h4>
                                <p class="font-web m-0 mb-5">{{ majorName }}</p>
                            </div>
                        </a-space>
                    </a-col>
                </a-row>
            </template>

            <div class="text-center" v-if="loading">
                <a-spin class="mt-20 mb-5">
                    <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
                </a-spin>
                <p class="font-weight-bold mt-5 mb-5">Loading...</p>
            </div>
            <div v-else class="mt-20 mb-20">
                <div v-if="dataProfileGrad.length != 0">
                    <div v-if="checkQr === ''">
                        <a-alert message="You have chosen not to attend the graduation ceremony to receive your degree."
                            description="Please contact Alumni Affairs and Career Development Group, Office of Student Affairs Mahidol University International College"
                            type="warning" />
                    </div>
                    <codegraduate v-else :dataPeriod="dataPeriod" :dataProfileGrad="dataProfileGrad" />
                </div>
                <div v-else>
                    <a-alert message="WARNING ALUMNI DATA PROFILE"
                        description="Please contact Alumni Affairs and Career Development Group, Office of Student Affairs Mahidol University International College"
                        type="warning" />
                </div>
                <!-- Intro Panel -->
                <!--  
                    <div class="survey-intro-section mt-20 mb-30 text-left">
                        <h4 class="font-web-bold mb-15" style="color: #00235e;">MUIC Graduate Employment Survey</h4>
                        <div class="scrollable-panel mb-20" style="max-height: 250px; overflow-y: auto; border: 1px solid #d9d9d9; padding: 16px; background: #fafafa; border-radius: 6px; font-size: 14px; line-height: 1.6;">
                            <p>The Graduate Survey of Mahidol University International College (MUIC) is an annual report in which all survey questions are being reviewed, examined and updated yearly in order to bridge the gap between Mahidol University requirements and Mahidol University International College.</p>
                            <p>Alumni Affairs and Career Development, Office of Student Affairs, Mahidol University International College collects and uses your personal data such as name-surname, email, mobile phone, education and occupation for the following purposes:</p>
                            <ol style="padding-left: 20px;">
                                <li>Education Criteria and Quality of Education</li>
                                <li>Legitimate interest of the College, for example, to keep alumni information up-to-date</li>
                            </ol>
                            <p>Your information will be disclosed to Education Administration Division, Office of the President, Mahidol University and other internal organizations related to the Quality of Education.</p>
                            <p>Alumni Affairs and Career Development Group, Office of Student Affairs, Mahidol University International College will retain your personal data for a period of 5 years. After the said period, MUIC needs to permanently keep some of your personal data for statistical and research analysis to improve the quality and procedure.</p>
                            <p>Your personal information will be protected according to the Personal Data Protection Act B.E. 2562 (2019) (PDPA). You have the right to access, rectify, erase, restrict or object to the processing of, and request portability of, your personal data. You may also withdraw consent at any time without affecting processing carried out prior to withdrawal.</p>
                            <p>In case of any inquiry or question on additional details regarding protection of your personal data, collection, use or disclosure of your personal data, please contact us via the following channels;</p>
                        </div>
                        <div class="survey-footer-section p-15 text-left" style="background: #e6f7ff; border-radius: 6px; border-left: 4px solid #1890ff; font-size: 14px;">
                            <p class="mb-5 font-weight-bold">Alumni Affairs and Career Development Group, Office of Student Affairs</p>
                            <p class="mb-10">Mahidol University International College<br>
                            999 Phutthamonthon 4 Road, Salaya Sub-district, Phutthamonthon District, Nakhon Pathom 73170<br>
                            Telephone: 02-700-5000</p>
                            <p class="mb-0 font-weight-bold text-success" style="color: #52c41a;">Thank you for your time and your valuable information.</p>
                        </div>
                    </div>
                -->
                <!--  
                    <a-row :gutter="24">
                        <a-col class="hide-on-mobile" :xs="0" :sm="0" :md="6" :lg="6">
                            <a-steps class="muic-survey-steps" :current="current" direction="vertical" size="small">
                            <a-step>
                                <template slot="title">
                                    <h6 class="muic-step-title font-web">Section 1</h6>
                                </template>
                                <template slot="description"><span class="muic-step-desc font-web">General
                                        Data</span></template>
                            </a-step>
                            <a-step>
                                <template slot="title">
                                    <h6 class="muic-step-title font-web">Section 2</h6>
                                </template>
                                <template slot="description"><span class="muic-step-desc font-web">Applied and Working
                                        (Currently
                                        Employed)</span></template>
                            </a-step>
                            <a-step>
                                <template slot="title">
                                    <h6 class="muic-step-title font-web">Section 3</h6>
                                </template>
                                <template slot="description"><span class="muic-step-desc font-web">Applied and Working
                                        (Unemployed)</span></template>
                            </a-step>
                            <a-step>
                                <template slot="title">
                                    <h6 class="muic-step-title font-web">Section 4</h6>
                                </template>
                                <template slot="description"><span class="muic-step-desc font-web">Further study (For the
                                        respondent who continues/wants to continue study)</span></template>
                            </a-step>
                            <a-step>
                                <template slot="title">
                                    <h6 class="muic-step-title font-web">Section 5</h6>
                                </template>
                                <template slot="description"><span class="muic-step-desc font-web">Suggestions</span></template>
                            </a-step>
                            <a-step>
                                <template slot="title">
                                    <h6 class="muic-step-title font-web">Section MUIC</h6>
                                </template>
                                <template slot="description"><span class="muic-step-desc font-web">Suggestions</span></template>
                            </a-step>
                            <a-step>
                                <template slot="title">
                                    <h6 class="muic-step-title font-web">Review</h6>
                                </template>
                                <template slot="description"><span class="muic-step-desc font-web">Submit</span></template>
                            </a-step>
                        </a-steps>
                        </a-col>
                        <a-col :xs="24" :sm="24" :md="18" :lg="18">
                            <a-card class="muic-form-card">

                            <keep-alive>
                                <component :is="dataComponent[current]" :current="current" @backSection="backSection"
                                @NextSectionB="NextSectionB" @NextSectionC="NextSectionC" @NextSectionD="NextSectionD"
                                @NextSectionE="NextSectionE" @NextSectionSubmit="NextSectionSubmit"
                                @NextSectionSkip="NextSectionSkip"
                                @updateData="updateData"
                                :allFormData="allFormData">
                            </component>
                            </keep-alive>
                        
                            </a-card>
                        </a-col>
                    </a-row>
                -->
            </div>
        </a-card>

    </div>
</template>

<script>

import codegraduate from './codegraduate.vue';
import stepA from './stepForm/stepA.vue';
import stepB from './stepForm/stepB.vue';
import stepC from './stepForm/stepC.vue';
import stepD from './stepForm/stepD.vue';
import stepE from './stepForm/stepE.vue';
import stepF from './stepForm/stepF.vue';
import stepSubmit from './stepForm/stepSubmit.vue';
import authService from '../../services/authService';

export default {
    components: {
        codegraduate,
        stepA,
        stepB,
        stepC,
        stepD,
        stepE,
        stepF,
        stepSubmit
    },
    data() {
        return {
            current: 0,
            dataComponent: ['stepA', 'stepB', 'stepC', 'stepD', 'stepE', 'stepF', 'stepSubmit'],
            allFormData: { stepA: {}, stepB: {}, stepC: {}, stepD: {}, stepE: {}, stepF: {} },
            historyStack: [],
            isMobile: false,
            // mock user info
            fullname: "",
            fullnameThai: "",
            picture: "",
            majorName: "",
            // skip
            loading: true,
            compleateForm: true,
            dataPeriod: [],
            dataProfileGrad: [],
            errorMsgRes: [],
            checkQr: '',
        };
    },
    mounted() {
        this.checkScreen();
        window.addEventListener('resize', this.checkScreen);
        this.getGradProfile();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreen);
    },
    methods: {
        async signOut() {
            try {
                await authService.logout();
            } catch (error) {
                console.error('Microsoft logout failed', error);
                this.$message.error('Sign out failed. Please try again.');
            }
        },
        checkScreen() {
            this.isMobile = window.innerWidth <= 768;
        },
        backSection() {
            if (this.historyStack.length > 0) {
                this.current = this.historyStack.pop();
            } else {
                if (this.current > 0) this.current -= 1;
            }
        },
        NextSectionB() {
            this.historyStack.push(this.current);
            this.current += 1;
        },
        NextSectionC() {
            this.historyStack.push(this.current);
            this.current += 1;
        },
        NextSectionD() {
            this.historyStack.push(this.current);
            this.current += 1;
        },
        NextSectionE() {
            this.historyStack.push(this.current);
            this.current += 1;
        },
        NextSectionSubmit() {
            this.historyStack.push(this.current);
            this.current += 1;
        },
        // skip
        updateData(stepName, data) {
            this.allFormData[stepName] = { ...this.allFormData[stepName], ...data };
        },
        NextSectionSkip(targetIndex) {
            this.historyStack.push(this.current);
            this.current = parseInt(targetIndex, 10);
        },
        // check profile
        async getGradProfile() {
            this.loading = true;
            this.dataPeriod = [];
            this.dataProfileGrad = [];
            this.errorMsgRes = [];
            try {
                const res = await this.$http.get(`/graduate-atk/profile/me/`);
                if (res.status === 200) {
                    // round
                    this.dataPeriod.push(res.data.date_check);
                    // gradInfo
                    this.dataProfileGrad.push(res.data.user);
                    // มา - ไม่มา
                    if (res.data.user.practise === "present") {
                        this.checkQr = "present";
                    } else {
                        this.checkQr = "";
                    }
                    // Profile
                    this.fullname = `${res.data.user.title_en} ${res.data.user.name_en}`
                    this.picture = `${res.data.user.img_url}`
                    this.majorName = `${res.data.user.major_en} ${res.data.user.bachelor}`
                    // loading
                    this.loading = false
                } else if (res.status === 204) {
                    this.errorMsgRes.push("No content Profile");
                    this.loading = false
                } else {
                    throw { res };
                }
            } catch (error) {
                this.errorMsgRes.push(error);
                this.dataProfileGrad = [];
                this.dataPeriod = [];
                this.loading = false
            }
        },
    },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@300;500&display=swap');

.logo-size {
    width: 300px;
    height: 100%;
    margin-top: 10px;
    z-index: -999;
}

.font-web {
    font-family: 'Sarabun', sans-serif;
}

.font-web-bold {
    font-family: 'Sarabun', sans-serif;
    font-weight: 900;
}

.muic-survey-wrapper {
    padding: 0;
    margin: 0;
}

/* Header */
.muic-survey-header {
    /* background-image: url('images/bg-signup.jpg'); */
    background-size: cover;
    background-position: center;
    text-align: center;
    padding: 30px 20px;
}

.muic-survey-header-content {
    color: #fff;
}

.muic-survey-title {
    font-size: 24px;
    margin-bottom: 10px;
}

.muic-survey-subtitle {
    font-size: 16px;
}

/* Card */
.muic-survey-card {
    margin: 20px;
}

/* Steps */
.muic-survey-steps {
    margin: 30px 0;
}

.muic-step-title {
    margin: 0;
    font-weight: 500;
    font-size: 14px;
}

.muic-step-desc {
    font-size: 12px;
    color: #888;
}

@media (max-width: 768px) {
    .muic-survey-title {
        font-size: 20px;
    }

    .muic-survey-heading {
        font-size: 16px;
    }

    .muic-survey-card {
        margin: 10px;
    }

    .ant-steps-item-description {
        display: none;
        /* ซ่อน description บนมือถือ */
    }

    .muic-step-title {
        font-size: 12px;
    }

    .muic-step-desc {
        display: none;
    }
}


.muic-survey-header-row {
    margin-bottom: 20px;
    padding: 0 10px;
}

.muic-survey-heading {
    margin: 0;
    font-size: 18px;
    text-align: left;
}

.muic-avatar-wrapper {
    text-align: right;
}

.avatar-info h4 {
    margin-bottom: 4px;
    font-size: 16px;
}

.avatar-info p {
    margin: 0;
    font-size: 14px;
}

@media (max-width: 768px) {
    .muic-survey-heading {
        text-align: center;
        margin-bottom: 10px;
    }

    .muic-avatar-wrapper {
        text-align: center;
        margin-top: 10px;
    }

    .muic-avatar-space {
        justify-content: center;
        width: 100%;
    }
}

@media (max-width: 768px) {
    .hide-on-mobile {
        display: none !important;
    }
}

.muic-form-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
</style>
